import { getDatadogInstance } from '@cw-elements/analytics-provider';
import { configureMonitoring, type MonitoringAdapter } from '@protector/api-client';
import { captureError } from 'infra/monitoring/monitoring.utils';

export const buildApiClientMonitoringAdapter = (): MonitoringAdapter => ({
  captureError: (error, { domain, ...rest }) => {
    captureError(error, { ...rest, domain: domain ?? 'Architecture' });
  },
  setGlobalContextProperty: (key, value) => {
    getDatadogInstance()?.setGlobalContextProperty(key, value);
  }
});

configureMonitoring(buildApiClientMonitoringAdapter());
